import { render, staticRenderFns } from "./TeamareaStats.vue?vue&type=template&id=60a9bf20&scoped=true&"
import script from "./TeamareaStats.vue?vue&type=script&lang=ts&"
export * from "./TeamareaStats.vue?vue&type=script&lang=ts&"
import style0 from "./TeamareaStats.vue?vue&type=style&index=0&id=60a9bf20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9bf20",
  null
  
)

export default component.exports